import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const TeaCupIllustration = ({ width = 174, marginLeft, marginRight, containerSize }: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 174 183">
      <defs>
        <path id="tawltkwq8a" d="M0.413 0.046L31 0.046 31 40.402 0.413 40.402z" />
        <path id="mbebubgtuc" d="M0.416 0.046L31.2 0.046 31.2 40.402 0.416 40.402z" />
        <path id="lcupjgwhee" d="M0 0.419L171.666 0.419 171.666 16 0 16z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(142 93)">
          <path
            fill="#6AB3A9"
            d="M8.343.046v9.208c0 10.955-2.736 21.643-7.93 31.148 9.752-3.008 30.588-11.834 30.588-32.33V.047H8.343z"
          />
        </g>
        <g transform="translate(142 93)">
          <path
            fill="#000"
            d="M8.397.046v9.208c0 10.954-2.754 21.643-7.981 31.148C10.23 37.394 31.2 28.568 31.2 8.072V.047H8.397z"
            opacity=".1"
          />
        </g>
        <path
          fill="#6AB3A9"
          d="M25 82v19.093C25 134.73 52.31 162 86 162c21.731 0 40.808-11.345 51.613-28.429 5.946-9.4 9.387-20.537 9.387-32.478V82H25z"
        />
        <path
          fill="#000"
          d="M146 101.093c0 11.94-3.385 23.078-9.233 32.478C126.14 150.654 107.375 162 86 162c0 0 21.24-11.279 21.24-80H146v19.093"
          opacity=".1"
        />
        <path
          fill="#B2B2B2"
          d="M75.424 50.877C85.876 67.09 75.601 71 75.601 71s18.387-6.951 10.379-22.5C77.972 32.95 80.52 26 80.52 26s-17.454 5.71-5.096 24.877M95.041 35.934C107.161 59.86 95.263 65 95.263 65s23.338-10.041 13.173-32.499C98.273 10.041 101.506 0 101.506 0S80.702 7.638 95.04 35.934"
        />
        <g transform="translate(0 167)">
          <path
            fill="#6AB3A9"
            d="M158.003 16H13.663C6.118 16 0 10.174 0 2.987 0 1.57 1.208.42 2.697.42H168.97c1.49 0 2.697 1.15 2.697 2.568 0 7.187-6.117 13.013-13.663 13.013"
          />
        </g>
        <path
          fill="#000"
          d="M86 167h83.298c1.492 0 2.702 1.18 2.702 2.637 0 7.38-6.129 13.363-13.69 13.363H86"
          opacity=".1"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
